import Header6_2 from './Header6_2.js'
export default Header6_2
